export default __webpack_public_path__ + "static/media/al.0ca528a4.svg";